export default __webpack_public_path__ + "static/media/icon_share.5d2038d5.svg";